import { render, staticRenderFns } from "./CustomerBankAccount.vue?vue&type=template&id=6001ac2d"
import script from "./CustomerBankAccount.vue?vue&type=script&lang=js"
export * from "./CustomerBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports